const Error = () => {
    return (
        <div>
            <p className="text-center"> There is no page in this route. </p>
        </div>
    );
};
export default Error;
